export var Breakpoints;
(function (Breakpoints) {
    Breakpoints[Breakpoints["XSmall"] = 320] = "XSmall";
    Breakpoints[Breakpoints["Small"] = 600] = "Small";
    Breakpoints[Breakpoints["Medium"] = 850] = "Medium";
    Breakpoints[Breakpoints["Large"] = 1200] = "Large";
})(Breakpoints || (Breakpoints = {}));
